<template>
    <div>
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <h3 style='display: inline-block'>{{ $t('account.title') || '账号' }}</h3>
                <el-alert
                    v-for='(item, index) in warningMsgList' :key='index'
                    style='margin-top: 1rem'
                    :title="item"
                    :closable='false'
                    type="warning">
                </el-alert>
            </div>
            <el-form label-position='left' inline :model='userInfo' :rules='rules' ref='updateAccountInfo'>
                <div v-if='updateUserInfoStatus.updateAccount'>
                    <el-form-item :label="$t('login.account') || '账号'" prop='account' key='updateAccount'>
                        <el-input size='mini' v-model='userInfo.account'
                                  :placeholder="$t('account.enterUsername') || '请输入用户名'" />
                    </el-form-item>
                    <el-form-item>
                        <el-button type='primary' size='mini' @click='submitUpdateUserInfo'>
                            {{ $t('common.change') || '更改' }}
                        </el-button>
                        <el-button size='mini' @click='updateUserInfoStatus.updateAccount = false'>
                            {{ $t('common.cancel') || '取消'
                            }}
                        </el-button>
                    </el-form-item>
                </div>
                <div v-if='!updateUserInfoStatus.updateAccount'>
                    <el-form-item :label="$t('login.account') || '账号'">
                        <span>{{userInfo.account}}</span>
                    </el-form-item>
                    <el-form-item>
                        <el-button icon='el-icon-edit' type='text' @click='updateUserInfoStatus.updateAccount = true'>
                            {{ $t('common.change') || '更改' }}
                        </el-button>
                    </el-form-item>
                </div>
                <el-form-item :label="$t('account.exitLogin') || '退出登录'">
                    <el-button type='danger' size='mini' @click='exitAccount'>{{ $t('common.exit') || '退出' }}
                    </el-button>
                </el-form-item>
            </el-form>
        </el-card>
        
        <add-or-update-phone :user-info='userInfo' />
        
        <add-or-update-email :user-info='userInfo' />
        
        <!-- 如果存在手机号，则通过手机号验证 -->
        <update-password :user-info='userInfo' />
        
        <el-card v-if='connectedThirdAccountList && connectedThirdAccountList.length > 0' style='margin-top: 2rem;'
                 class='box-card'>
            <div slot='header' class='clearfix'>
                <h3>{{ $t('account.thirdPartyAccounts') || '关联的第三方账户' }}</h3>
            </div>
            <div>
                <el-descriptions :colon='false' v-for='(item, index) in connectedThirdAccountList' :key='index'>
                    <el-descriptions-item :label="$t('account.platform') || '平台'">{{ item.issuer }}
                    </el-descriptions-item>
                    <el-descriptions-item :label="$t('account.createDate') || '创建日期'">{{ item.createTime }}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <el-button type='text' @click='handleDisconnect(item)'>{{ $t('account.disconnect') || '取消绑定'
                            }}
                        </el-button>
                    </el-descriptions-item>
                </el-descriptions>
            </div>
        </el-card>
        
        <el-card style='margin-top: 2rem;' class="box-card">
            <div slot="header" class="clearfix">
                <h3>{{ $t('account.other') || '其他' }}</h3>
            </div>
            <div>
                <el-form class="demo-ruleForm">
                    <el-form-item :label="$t('account.registerTime') || '注册时间'" prop='password'>
                        <p>{{userInfo.createTime}}</p>
                    </el-form-item>
                    <el-form-item :label="$t('account.loginPlatform') || '登录平台'" prop='password'>
                        <el-tag v-for='(item, index) in computedPlatformArr' style='margin-right: 1rem;' :key='index'>{{item}}</el-tag>
                    </el-form-item>
                    <el-form-item :label="$t('account.deleteAccount') || '账号注销'">
                        <el-button type='danger' size='mini' @click='deleteAccount'>
                            {{ $t('account.deleteAccount') || '注销' }}
                        </el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-card>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import { accountApi } from '@/service/api/accountApi';
import { message } from '@/utils/message';
import { localStg } from '@/utils/storage/local';
import AddOrUpdateEmail from '@view/account/AddOrUpdateEmail.vue';
import AddOrUpdatePhone from '@view/account/AddOrUpdatePhone.vue';
import UpdatePassword from '@view/account/UpdatePassword.vue';
import { EnumLocalStore } from '@/constant/enums';

export default defineComponent({
    name: 'index',
    components: { UpdatePassword, AddOrUpdatePhone, AddOrUpdateEmail },
    data() {
        return {
            userInfo: {},
            updateUserInfoStatus: {
                updateAccount: false,
                updateEmail: false,
                updatePhone: false
            },
            warningMsgList: [],
            time: undefined,
            updatePwdTime: undefined,
            rules: {
                account: [
                    {
                        validator: (rule, value, callback) => {
                            if (!value) {
                                callback(new Error(this.$t('login.enterAccount') || '请输入账号'));
                            }else {
                                callback()
                            }
                        }
                    }
                ],
            },
            connectedThirdAccountList: []
        }
    },
    created() {
        this.getUserInfo()
        this.getThirdAccountList();
    },
    computed: {
        computedPlatformArr() {
            if (!this.userInfo.platform) {
                return []
            }
            return this.userInfo.platform.split(",")
        }
    },
    methods: {
        getUserInfo() {
            accountApi.queryUserDetailInfo().then(result => {
                if (result.code === 200) {
                    this.userInfo = result.data
                    if (!this.userInfo.passwordStatus) {
                        this.warningMsgList.push(this.$t('account.noPasswordWarning') || '您的账号未设置密码，为了登录方便以及保证您的账号安全，请设置密码');
                    }
                    if (!this.userInfo.phone) {
                        this.warningMsgList.push(this.$t('account.noPhoneWarning') || '您的账号未绑定手机号，为了登录方便以及保证您的账号安全，请绑定手机号');
                    }
                    if (!this.userInfo.email) {
                        this.warningMsgList.push(this.$t('account.noEmailWarning') || '您的账号未绑定邮箱，为了登录方便以及保证您的账号安全，请绑定邮箱');
                    }
                }
            })
        },
        getThirdAccountList() {
            this.connectedThirdAccountList = [];
            accountApi.thirdAccountList().then(result => {
                if (result.data) {
                    this.connectedThirdAccountList = result.data;
                }
            });
        },
        submitUpdateUserInfo() {
            this.$refs.updateAccountInfo.validate((valid) => {
                if (!valid) {
                    return false
                }
                accountApi.updateUserInfo(this.userInfo).then(result => {
                    if (result.code === 200) {
                        message.success(this.$t('account.changeSuccess') || '更改成功');
                    }
                })
            });
        },
        formValidate(formName) {
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    return false
                }
            });
        },
        exitAccount() {
            localStg.remove(EnumLocalStore.jwtTokenName);
            this.$router.push('/login')
        },
        deleteAccount() {
            let obj = this
            this.$modal.confirm(`${this.$t('account.deleteConfirm', { account: this.userInfo.account }) || '是否确定要注销' + this.userInfo.account + '账户？账户注销之后，会有15天的缓冲期，15天内，再次登录，会重新激活该账户。如果15天后，该账户未被重新激活，则账户会被自动删除！'}`).then(function() {
                return accountApi.deletePlayer()
            }).then((result) => {
                if (result.code === 200) {
                    message.success(this.$t('account.deleteSuccess') || '注销成功');
                    obj.exitAccount()
                }
            }).catch(() => {
            });
        },
        handleDisconnect(item) {
            let obj = this;
            this.$modal.confirm(`${this.$t('account.disconnectConfirm', { platform: item.issuer }) || '确定要取消 ' + item.issuer + ' 和您的账号的绑定状态? 取消后, 您将无法使用该平台进行快捷登录'}`).then(function() {
                return accountApi.disconnectThirdAccount(item.thirdUserId);
            }).then((result) => {
                if (result.code === 200) {
                    message.success(this.$t('account.disconnectSuccess') || '取消绑定成功');
                    obj.getThirdAccountList();
                }
            }).catch(() => {
            });
        }
    }
});
</script>

<style scoped lang='css'>
.account-input {
    width: 40%;
}
</style>
